<div class="container">
  <div class="title">
    {{ title }}
  </div>
  <div class="body" fxLayoutAlign="start stretch">
    {{ description }}
  </div>

  <div class="buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-button (click)="close()" text="Annuler" btnType="text"></app-button>
    <app-button (click)="generate()" btnType="primary" color="primary" text="{{ generateBtnTitle }}"></app-button>
  </div>
</div>
